import {Router} from 'ninelines-router';
import vars from './helpers';
import aos from './components/aos';
import footer from './components/footer';
import popup from './components/popup';
import menu from './components/menu';
import slider from './components/slider';
import check from './components/check';
import animation from './components/animation';
import analytics from './components/analytics';
import scrollDepth from 'scroll-depth';

let router = new Router();

menu.init();
footer.init();
aos.init();

router.addRoute({
	path: '/',
	name: 'home',
	onEnter(prevState) {
		return new Promise((resolve) => {
			vars.$html.data('page', 'home').attr('data-page', 'home');

			// let page = 'home';

			const tl = gsap.timeline();

			vars.gsapCleaner(vars.$siteContainer);

			tl
				.from(vars.$siteContainer, {
					onStart() {
						vars.$home.removeClass('is-hidden');
						vars.$siteContainer.removeClass('is-hidden');

						// aos.refresh();

						window.scrollTo(0, 0);
					},
					onComplete() {
						if (prevState.route) {
							analytics.start15SecTimeout();
							analytics.virtualHit(location.pathname);
							scrollDepth.reset();
						}

						resolve();
					},
					duration: 1,
					autoAlpha: 0,
					clearProps: 'all',
				}, 0.5)
			;

			if (!vars.isMobile()) {
				animation.home(tl);
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			vars.gsapCleaner(vars.$siteContainer);

			gsap
				.to(vars.$siteContainer, {
					onStart() {
						// $('[data-aos-id="home-animation"]').data('view', '0');
						// $('.js-aos-obj').each((i, obj) => {
						// 	if (!$(obj).hasClass('is-hidden-desktop')) {
						// 		$(obj).addClass('is-hidden-desktop');
						// 	}
						// });
					},
					onComplete() {
						vars.$siteContainer.addClass('is-hidden');
						vars.$home.addClass('is-hidden');
						footer.destroy();
						menu.destroy();

						resolve();
					},
					duration: 0.5,
					autoAlpha: 0,
					clearProps: 'all',
				})
			;
		});
	},
});

router.addRoute({
	path: '/game/:id',
	name: 'game',
	onEnter(prevState, currentState) {
		return new Promise((resolve) => {
			let id = currentState.params.id;
			// let $page = $(`.page[data-card="${id}"]`);
			let page = 'game';

			vars.$html
				.data('page', page)
				.data(page, id)
				.attr('data-page', page)
				.attr('data-card', id);

			let $container;
			let start;

			const $gameSection = vars.$document.find(`.js-game-${id}`);

			if (!prevState.route || prevState.route && prevState.route.name !== 'game') {
				$container = vars.$siteContainer;

				start = () => {
					vars.$siteContainer.removeClass('is-hidden');
					vars.$game.removeClass('is-hidden');
					$gameSection.removeClass('is-hidden');
				};
			} else {
				$container = $gameSection;

				if (vars.isMobile() || id === 'result') {
					$container = vars.$siteContainer;
				}

				start = () => {
					$gameSection.removeClass('is-hidden');

					// if (prevState.params.id === 'start') {
					// 	history.pushState(null, null, '?s=1&r=1&l=1');
					// }
					// console.log(currentState.query);
				};
			}

			vars.gsapCleaner($container);

			const tl = gsap.timeline();

			tl
				.from($container, {
					onStart() {
						if (id === 'step') {
							slider.init();
							check.init();
							vars.$document.find('.js-step-text').removeClass('is-hidden');
						}

						start();

						// aos.refresh();

						window.scrollTo(0, 0);
					},
					onComplete() {
						if (prevState.route) {
							analytics.start15SecTimeout();
							analytics.virtualHit(location.pathname);
							scrollDepth.reset();
						}

						resolve();
					},
					duration: 1,
					autoAlpha: 0,
					clearProps: 'all',
				}, 0.5)
			;

			if (!vars.isMobile() && id === 'start') {
				animation.start(tl);
			}

			if (!vars.isMobile() && id === 'step') {
				animation.step(tl);
			}
		});
	},
	onLeave(currentState, nextState) {
		return new Promise((resolve) => {
			let id = currentState.params.id;
			let $container;
			let complete;
			let $gameSection = vars.$document.find(`.js-game-${id}`);

			if (nextState.route.name !== 'game') {
				$container = vars.$siteContainer;

				complete = () => {
					$gameSection.addClass('is-hidden');
					vars.$game.addClass('is-hidden');
					vars.$siteContainer.addClass('is-hidden');

					slider.destroy();
					check.destroy();
				};
			} else {
				$container = $gameSection;

				if (vars.isMobile() || nextState.params.id === 'result') {
					$container = vars.$siteContainer;
				}

				complete = () => {
					$gameSection.addClass('is-hidden');

					if (nextState.params.id !== 'step') {
						slider.destroy();
						check.destroy();
						// vars.$document.find('.js-game-step').removeClass('is-hidden');
					}
				};
			}

			vars.gsapCleaner($container);

			const tl = gsap.timeline();

			tl
				.to($container, {
					onComplete() {
						complete();

						// vars.$html.trigger('page-leave');

						vars.$html.removeData('card');
						vars.$html.removeAttr('data-card');
						vars.$html.removeData('template');
						vars.$html.removeAttr('data-template');

						footer.destroy();
						menu.destroy();

						resolve();
					},
					duration: 0.5,
					autoAlpha: 0,
					clearProps: 'all',
				})
			;
		});
	},
});

router.addRoute({
	path: '/article',
	name: 'article',
	onEnter(prevState) {
		return new Promise((resolve) => {
			vars.$html.data('page', 'article').attr('data-page', 'article');

			let page = 'article';

			vars.gsapCleaner(vars.$siteContainer);

			const tl = gsap.timeline();

			tl
				.from(vars.$siteContainer, {
					onStart() {
						vars.$article.removeClass('is-hidden');
						vars.$siteContainer.removeClass('is-hidden');

						popup.init();
						aos.refresh();
						// analytics.info('init');

						window.scrollTo(0, 0);
					},
					onComplete() {
						if (prevState.route) {
							analytics.start15SecTimeout();
							analytics.virtualHit(location.pathname);
							scrollDepth.reset();
						}

						resolve();
					},
					duration: 0.5,
					autoAlpha: 0,
					clearProps: 'all',
				})
			;

			if (!vars.isMobile()) {
				animation.article(tl);
			}
		});
	},
	onLeave() {
		return new Promise((resolve) => {
			let page = 'article';

			vars.gsapCleaner(vars.$siteContainer);

			gsap
				.to(vars.$siteContainer, {
					onStart() {

					},
					onComplete() {
						vars.$siteContainer.addClass('is-hidden');
						vars.$article.addClass('is-hidden');
						// vars.$article.find('.js-info').attr('data-view', 'false');

						aos.articleDestroy();
						popup.destroy();
						footer.destroy();
						menu.destroy();

						// analytics.info('destroy');
						resolve();
					},
					duration: 0.5,
					autoAlpha: 0,
					clearProps: 'all',
				})
			;
		});
	},
});

router.on('notFound', () => {
	router.navigate('/');

	return Promise.resolve();
});

router.start();

export default router;
